import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { BookAccessDetailsService } from '../../../../api/api-services/book-access-details.service';
import { IBookAccessHistoryMetaVm } from '../../../../api/book-access-history-meta-vm.model';
import { eModalRoles } from '../../../shared/models/modals';

@Component({
  selector: 'app-book-access-package-edit',
  templateUrl: './book-access-package-edit.component.html',
  styleUrl: './book-access-package-edit.component.scss',
})
export class BookAccessPackageEditComponent implements OnInit {
  private _bookAccessDetailsService = inject(BookAccessDetailsService);
  private _messageService = inject(MessageService);
  private _dialogRef = inject(DynamicDialogRef);
  private _dialogConfig = inject(DynamicDialogConfig);
  private _fb = inject(FormBuilder);

  public editForm!: FormGroup;
  public loading = false;

  private bookAccessPackage!: IBookAccessHistoryMetaVm;

  ngOnInit(): void {
    this.bookAccessPackage = this._dialogConfig.data;
    this.editForm = this._fb.group({
      noTimeLimit: [this.bookAccessPackage.validDays === 0],
      validDays: [this.bookAccessPackage.validDays || null],
    });
  }

  closeDialog(status: eModalRoles = eModalRoles.CLOSE): void {
    this._dialogRef.close(status);
  }

  save(): void {
    this.loading = true;
    const noTimeLimit = this.editForm.value.noTimeLimit;
    this._bookAccessDetailsService
      .put({
        guid: this.bookAccessPackage.guid,
        timeLimit: !noTimeLimit,
        validDays: noTimeLimit ? undefined : this.editForm.value.validDays,
        printed: this.bookAccessPackage.printed,
      })
      .subscribe({
        next: () => {
          this.loading = false;
          this._messageService.add({
            severity: 'success',
            summary: 'Sukces',
            detail: 'Lista została zaktualizowana.',
          });
          this.closeDialog(eModalRoles.SUCCESS);
        },
        error: (err) => {
          this.loading = false;
          console.error('Book access package update error:', err);
          this._messageService.add({
            severity: 'error',
            summary: 'Błąd',
            detail: 'Wystąpił błąd. Spróbuj ponownie później.',
          });
        },
      });
  }
}
